<template>
  <div class="track-container">
    <span class="range-value min">
      {{ minValue.toFixed(2) }}
    </span>
    <span class="range-value max">
      {{ maxValue.toFixed(2) }}
    </span>
    <div class="track" :ref="'_vpcTrack_' + name"></div>
    <div class="track-highlight" :ref="'trackHighlight_' + name"></div>
    <button class="track-btn track1" :ref="'track1_' + name"></button>
    <button class="track-btn track2" :ref="'track2_' + name"></button>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle, no-unused-vars */
export default {
  data() {
    return {
      minValue: 0,
      maxValue: 0,
      totalSteps: 0,
      percentPerStep: 1,
      trackWidth: null,
      isDragging: false,
      pos: {
        curTrack: null
      }
    };
  },
  props: {
    min: Number,
    max: Number,
    name: String,
    step: {
      type: Number,
      default() {
        return 1;
      }
    }
  },
  watch: {
    min: function(value){
      if (value != this.minValue) {
        this.resetSlider();
      }
    },
    max: function(value){
      if (value != this.maxValue) {
        this.resetSlider();
      }
    }
  },
  methods: {
    moveTrack(track, ev) {
      this.totalSteps = (this.max - this.min) / this.step;
      this.percentPerStep = 100 / this.totalSteps;
      const percentInPx = this.getPercentInPx();

      const trackX = Math.round(this.$refs["_vpcTrack_" + this.name].getBoundingClientRect().left);
      const { clientX } = ev;
      const moveDiff = clientX - trackX;

      const moveInPct = moveDiff / percentInPx;

      if (moveInPct < 1 || moveInPct > 100) return;
      const value = Math.ceil(moveInPct / this.percentPerStep) * this.step + this.min;

      if (track === "track1") {
        if (value >= this.maxValue - this.step) return;
        this.minValue = value;
      }

      if (track === "track2") {
        if (value <= this.minValue + this.step) return;
        this.maxValue = value;
      }

      this.$refs[track + "_" + this.name].style.left = `${moveInPct}%`;
      this.setTrackHightlight();
    },
    mousedown(ev, track) {
      if (this.isDragging) return;
      this.isDragging = true;
      this.pos.curTrack = track;
    },

    touchstart(ev, track) {
      this.mousedown(ev, track);
    },

    mouseup(ev, track) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.$emit("min-changed", this.minValue);
      this.$emit("max-changed", this.maxValue);
    },

    touchend(ev, track) {
      this.mouseup(ev, track);
      this.$emit("min-changed", this.minValue);
      this.$emit("max-changed", this.maxValue);
    },

    mousemove(ev, track) {
      if (!this.isDragging) return;
      this.moveTrack(track, ev);
    },

    touchmove(ev, track) {
      this.mousemove(ev.changedTouches[0], track);
    },

    valueToPercent(value) {
      return ((value - this.min) / this.step) * this.percentPerStep;
    },

    setTrackHightlight() {
      this.$refs["trackHighlight_" + this.name].style.left = `${this.valueToPercent(
        this.minValue
      )}%`;
      this.$refs["trackHighlight_" + this.name].style.width = `${this.valueToPercent(
        this.maxValue
      ) - this.valueToPercent(this.minValue)}%`;
    },

    getPercentInPx() {
      const trackWidth = this.$refs["_vpcTrack_" + this.name].offsetWidth;
      const oneStepInPx = trackWidth / this.totalSteps;
      // 1 percent in px
      const percentInPx = oneStepInPx / this.percentPerStep;

      return percentInPx;
    },

    resetSlider() {
      // calc per step value
      this.totalSteps = (this.max - this.min) / this.step;
      this.minValue = this.min;
      this.maxValue = this.max;
      // percent the track button to be moved on each step
      this.percentPerStep = 100 / this.totalSteps;

      // set track1 initilal
      document.querySelector(".track1").style.left = `${this.valueToPercent(this.minValue)}%`;
      // track2 initial position
      document.querySelector(".track2").style.left = `${this.valueToPercent(this.maxValue)}%`;
      // set initila track highlight
      this.setTrackHightlight();
    },

    setClickMove(ev) {
      const track1Left = this.$refs["track1_" + this.name].getBoundingClientRect().left;
      const track2Left = this.$refs["track2_" + this.name].getBoundingClientRect().left;
      if (ev.clientX < track1Left) {
        this.moveTrack("track1", ev);
      } else if (ev.clientX - track1Left < track2Left - ev.clientX) {
        this.moveTrack("track1", ev);
      } else {
        this.moveTrack("track2", ev);
      }
      this.$emit("min-changed", this.minValue);
      this.$emit("max-changed", this.maxValue);
    }
  },

  mounted() {
    this.resetSlider();

    const self = this;

    ["mouseup", "mousemove"].forEach(type => {
      document.body.addEventListener(type, ev => {
        // ev.preventDefault();
        if (self.isDragging && self.pos.curTrack) {
          self[type](ev, self.pos.curTrack);
        }
      });
    });

    ["mousedown", "mouseup", "mousemove", "touchstart", "touchmove", "touchend"].forEach(type => {
      document.querySelector(".track1").addEventListener(type, ev => {
        ev.stopPropagation();
        self[type](ev, "track1");
      });

      document.querySelector(".track2").addEventListener(type, ev => {
        ev.stopPropagation();
        self[type](ev, "track2");
      });
    });

    // on track clik
    // determine direction based on click proximity
    // determine percent to move based on track.clientX - click.clientX
    document.querySelector(".track").addEventListener("click", ev => {
      ev.stopPropagation();
      self.setClickMove(ev);
    });

    document.querySelector(".track-highlight").addEventListener("click", ev => {
      ev.stopPropagation();
      self.setClickMove(ev);
    });
  }
};
</script>

<style lang="scss" scoped>
.track-container {
  width: 100%;
  position: relative;
  cursor: pointer;
  margin-top: 4rem;
  height: 0.5rem;

  .range-value {
    position: absolute;
    top: -3rem;
    display: none;

    &.min {
      left: 0;
    }

    &.max {
      right: 0;
    }
  }

  .track,
  .track-highlight {
    display: block;
    position: absolute;
    width: 100%;
    height: 0.5rem;
  }

  .track {
    background-color: #ddd;
  }

  .track-highlight {
    background-color: black;
    z-index: 2;
  }

  .track-btn {
    appearance: none;
    outline: none;
    cursor: pointer;
    display: block;
    position: absolute;
    z-index: 2;
    width: 1.5rem;
    height: 1.5rem;
    top: calc(-50% - 0.25rem);
    margin-left: -1rem;
    border: none;
    background-color: black;
    touch-action: pan-x;
    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out, background-color 0.3s ease;
  }
}
</style>
